import { render, staticRenderFns } from "./accept-invite.vue?vue&type=template&id=a833e79e&lang=pug&"
import script from "./accept-invite.vue?vue&type=script&lang=js&"
export * from "./accept-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports